
if (!window.pajpApp || typeof window.pajpApp == "undefined") {
  window.pajpApp = {};
}

window.pajpApp.wishlist_products = function () {
  var cemail = 'pajp_customer_email';
  var chandle = 'pajp_products_handle';
  var add_to_wsl_btn_class = 'pajp-add-to-wsl-btn';
  var remove_from_wsl_btn_class = 'pajp-remove-from-wsl-btn';
  var add_wsl_url = '/add_to_wishlist';
  var remove_wsl_url = '/remove_from_wishlist';
  var clicked_add_button = "";
  var clicked_remove_button = "";
  var that = this;

  this.add_product = function () {
    var that = this;
    var a = document.querySelectorAll('.' + add_to_wsl_btn_class);
    a.forEach(function (item, index) {
      if (typeof item.addEventListener != "function") {
        return;
      }
      item.addEventListener('click', function (e) {
        var addwsl = this;
        clicked_add_button = addwsl;
        var customer_id = addwsl.getAttribute("data-pajp-customer-id");
        var customer_email = addwsl.getAttribute("data-pajp-customer-email");
        var product_id = addwsl.getAttribute("data-pajp-product-id");
        var variant_id = addwsl.getAttribute("data-pajp-variant-id");
        var product_handle = addwsl.getAttribute("data-pajp-product-handle");
        var product_title = addwsl.getAttribute("data-pajp-product-title");
        var variant_title = $(".variant__label-info span").text().trim() + " / " + $("select.sized").val();
        //var product_image = addwsl.getAttribute("data-pajp-product-image");
        var product_image = $("#pwzrswiper-slide-0 img").attr("src");
        var product_price = $(".product__price").text().trim();
        var page = addwsl.getAttribute("data-page");
        var shop_id = addwsl.getAttribute("data-pajp-shop-id");
        var token = document.getElementById("pajp-wsl-token").value;
        
        //clicked_add_button.disabled = true;
        var wsl_btn = addwsl.parentNode;
        var count = 0;
        var wsl_product_count = 0;
        switch (page) {
          case "product-page":
          case "collection-page":
            wsl_btn.getElementsByClassName("pajp-add-to-wsl-btn")[0].style.display = "none";
            wsl_btn.getElementsByClassName("pajp-remove-from-wsl-btn")[0].style.display = "inline-block";
            if (wsl_btn.parentNode.getElementsByClassName('pajp-wsl-product-count')[0]) {
              count = parseInt(wsl_btn.parentNode.getElementsByClassName('pajp-wsl-product-count')[0].innerHTML);
              wsl_product_count = parseInt(count) + 1;
              wsl_btn.parentNode.getElementsByClassName("pajp-wsl-product-count")[0].innerHTML = wsl_product_count;
            }
            break;
        }
        var ajax = that.get_ajax_obj();
        ajax.onreadystatechange = function () {
          if (/*this.readyState == 4*/ true) {
            if (/*this.status == 200*/ true) {
              clicked_add_button.disabled = false;
              var res = JSON.parse(this.responseText);
              //that.setCookie(chandle, res.products_handle, 15);
              switch (page) {
                case "product-page":
                case "collection-page":
                  wsl_btn.getElementsByClassName("pajp-add-to-wsl-btn")[0].style.display = "none";
                  wsl_btn.getElementsByClassName("pajp-remove-from-wsl-btn")[0].style.display = "inline-block";
                  if (wsl_btn.parentNode.getElementsByClassName('pajp-wsl-product-count')[0]) {
                    wsl_btn.parentNode.getElementsByClassName("pajp-wsl-product-count")[0].innerHTML = wsl_product_count;
                  }
                  break;
              }
            } else {

            }
          }
        };
        axios.post('https://pajphost.com/customer/public/api/addToWishlist', {
          customer_id: customer_id,
          product_id: product_id,
          variant_id: variant_id,
          image_src: product_image,
          product_handle: product_handle,
          product_title: product_title,
          variant_title: variant_title,
          price: product_price,
          shop_id: shop_id,
        })
        .then(function(response){
        	//console.log(response);
        })
        .catch(function(error){
        	console.log(error);
        });
        /*ajax.open("POST", url, true);
        ajax.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        var data = that.serialize(
          {
            token: token,
            customer_id: customer_id,
            customer_email: customer_email,
            product_id: product_id,
            product_handle: product_handle,
            product_title: product_title,
            product_image: product_image,
            wsl_product_count: wsl_product_count
          });
        ajax.send(data);*/
      });
    })
  };

  this.get_ajax_obj = function () {
    if (window.XMLHttpRequest) { // Mozilla, Safari, IE7+ ...
      return new XMLHttpRequest();
    } else if (window.ActiveXObject) { // IE 6 and older
      return new ActiveXObject("Microsoft.XMLHTTP");
    }
  };
  
  this.remove_product = function () {
    var that = this;
    var a = document.querySelectorAll('.' + remove_from_wsl_btn_class);
    a.forEach(function (item, index) {
      if (typeof item.addEventListener != "function") {
        return;
      }
      item.addEventListener('click', function (e) {
        var removewsl = this;
        clicked_remove_button = removewsl;
        var customer_id = removewsl.getAttribute("data-pajp-customer-id");
        var customer_email = removewsl.getAttribute("data-pajp-customer-email");
        var product_id = removewsl.getAttribute("data-pajp-product-id");
        var variant_id = removewsl.getAttribute("data-pajp-variant-id");
        var product_handle = removewsl.getAttribute("data-pajp-product-handle");
        var product_title = removewsl.getAttribute("data-pajp-product-title");
        var product_image = removewsl.getAttribute("data-pajp-product-image");
        var page = removewsl.getAttribute("data-page");
        var shop_id = removewsl.getAttribute("data-pajp-shop-id");
        var token = document.getElementById("pajp-wsl-token").value;
        
        //clicked_remove_button.disabled = true;
        var wsl_btn = removewsl.parentNode;
        var count = 0;
        var wsl_product_count = 0;
        switch (page) {
          case "product-page":
          case "collection-page":
            wsl_btn.getElementsByClassName("pajp-remove-from-wsl-btn")[0].style.display = "none";
            wsl_btn.getElementsByClassName("pajp-add-to-wsl-btn")[0].style.display = "inline-block";
            if (wsl_btn.parentNode.getElementsByClassName('pajp-wsl-product-count')[0]) {
              count = parseInt(wsl_btn.parentNode.getElementsByClassName('pajp-wsl-product-count')[0].innerHTML);
              wsl_product_count = parseInt(count) - 1;
              if (wsl_product_count <= 0) {
                wsl_product_count = 0;
              }
              wsl_btn.parentNode.getElementsByClassName("pajp-wsl-product-count")[0].innerHTML = wsl_product_count;
            }
            break;
           case "account-wsl-page":
            if (document.querySelector(".pajp-remove-from-wsl-btn[data-pajp-product-id='" + product_id + "']")) {
              //console.log("Entro al 1er div");
              document.querySelector(".pajp-remove-from-wsl-btn[data-pajp-product-id='" + product_id + "']").closest("div .pajp-wsl-product-row").remove();
              var removewsl = document.querySelectorAll(".pajp-wsl-product-row");
              if (removewsl.length < 1) {
                document.querySelector('.pajp-wishlist-ul').classList.add("pajp-hidden");
                document.querySelector('.pajp-wsl-view-empty').classList.remove("pajp-hidden");
              }
            }
            that.reset_pagination();
            break;
        }
        var ajax = that.get_ajax_obj();
        ajax.onreadystatechange = function () {
          if (this.readyState == 4) {
            if (this.status == 200) {
              clicked_remove_button.disabled = false;
              var res = JSON.parse(this.responseText);
              //that.setCookie(chandle, res.products_handle, 15);
              switch (page) {
                case "product-page":
                case "collection-page":
                  wsl_btn.getElementsByClassName("pajp-remove-from-wsl-btn")[0].style.display = "none";
                  wsl_btn.getElementsByClassName("pajp-add-to-wsl-btn")[0].style.display = "inline-block";
                  if (wsl_btn.parentNode.getElementsByClassName('pajp-wsl-product-count')[0]) {
                    wsl_btn.parentNode.getElementsByClassName("pajp-wsl-product-count")[0].innerHTML = wsl_product_count;
                  }
                  break;
                case "account-wsl-page":
                  if (document.querySelector(".pajp-remove-from-wsl-btn[data-pajp-product-id='" + product_id + "']")) {
                    document.querySelector(".pajp-remove-from-wsl-btn[data-pajp-product-id='" + product_id + "']").closest("div .pajp-wsl-product-row").remove();
                    var removewsl = document.querySelectorAll(".pajp-wsl-product-row");
                    if (removewsl.length < 1) {
                      document.querySelector('.pajp-wishlist-ul').classList.add("pajp-hidden");
                      document.querySelector('.pajp-wsl-view-empty').classList.remove("pajp-hidden");
                    }
                  }
                  that.reset_pagination();
                  break;
              }
            } else {

            }
          }
        };
        axios.post('https://pajphost.com/customer/public/api/removeFromWishlist', {
          customer_id: customer_id,
          product_id: product_id,
          variant_id: variant_id,
          shop_id: shop_id,
        })
        .then(function(response){
          	var removewsl = document.querySelectorAll(".pajp-wsl-product-row");
            if (removewsl.length < 1) {
              document.querySelector('.pajp-wishlist-ul').classList.add("pajp-hidden");
              document.querySelector('.pajp-wsl-view-empty').classList.remove("pajp-hidden");
            }
        	//console.log(response);
        })
        .catch(function(error){
        	console.log(error);
        });
        
      });
    });
  };

  this.serialize = function (obj) {
    var str = [];
    for (var p in obj)
      if (obj.hasOwnProperty(p)) {
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
      }
    return str.join("&");
  };

  this.isNull = function (t) {
    return (typeof t == "undefined" || t == null || t.trim() == "");
  };

  this.add_to_cart_event = function () {
    
    var add_cart = document.querySelectorAll('.pajp-wsl-add-to-cart');
    var that = this;
    add_cart.forEach(function (item, index) {
      if (typeof item.addEventListener != "function") {
        return;
      }
      item.addEventListener('click', function (e) {
        var id = select.options[select.selectedIndex].value;
        console.log(id);
        return true;
        //var quantity = this.closest('li').querySelector('.pajp-wsl-product-variant-quantity').value;
        /*var select = this.closest('li').querySelector('.product-variant-options');
        
        var data = "id=" + id + "&quantity=1";
        that.addToCart(data, function (line_item) {
          location.href = "/cart";
        }, function () {});*/
        
        axios.post('/cart/add.js', {
          items: [
            {
              quantity: 1,
              id: id
            }
          ]
        })
        .then(function(response){
        	console.log(response);
        })
        .catch(function(error){
        	console.log(error);
        });
        
      });
    });
  };

  this.addToCart = function (data, suc_callback, error_callback) {
    var that = this;

    var ajax = that.get_ajax_obj();
    ajax.onreadystatechange = function () {
      if (this.readyState == 4) {
        if (this.status == 200) {
          var line_item = JSON.parse(this.responseText);
          if (typeof suc_callback == "function") {
            suc_callback(line_item);
          }
        } else {
          if (typeof error_callback == "function") {
            error_callback(res);
          }
        }
      }
    };
    
    ajax.open("POST", '/cart/add.js', true);
    ajax.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    ajax.send(data);
  }
  
  
  
  this.addCLickEventVariantSwatch = function(){
  	var swatch_element = document.querySelectorAll('.swatch .swatch-element input');

    swatch_element.forEach(function (item, index) {
      
      item.addEventListener('click', function (e) {
        
        waitForUrlChange = setTimeout(function(){
        	const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);

            const variant = urlParams.get('variant')
            //console.log(variant);

            //asignar el nuevo variant a los botones de add y remove
            //var variant_id = addwsl.getAttribute("data-pajp-variant-id");
            $('.pajp-add-to-wsl-btn').attr("data-pajp-variant-id", variant);
            $('.pajp-remove-from-wsl-btn').attr("data-pajp-variant-id", variant);
        
        window.pajpApp.check_wishlist();
          
        }, 100);
        
        
      });
    });
  };

  //window.pajpApp.check_wishlist();
  this.add_product();
  this.remove_product();
  this.addCLickEventVariantSwatch();
  
  if (location.pathname != "/account") {
    //this.flits_wsl_guest_login();
  }

  if (location.pathname == "/customer-world"){
  	
  }
  
  if (location.pathname == "/account") {
    /*this.wsl_pagination();
    this.change_variant_price();
    this.add_to_cart_event();*/
  }

};

window.pajpApp.check_wishlist = function () {
      var addwsl = document.querySelector('.pajp-add-to-wsl-btn');
      //clicked_add_button = addwsl;
      var customer_id = addwsl.getAttribute("data-pajp-customer-id");
      var customer_email = addwsl.getAttribute("data-pajp-customer-email");
      var product_id = addwsl.getAttribute("data-pajp-product-id");
      var variant_id = addwsl.getAttribute("data-pajp-variant-id");
      var product_handle = addwsl.getAttribute("data-pajp-product-handle");
      var product_title = addwsl.getAttribute("data-pajp-product-title");
      var product_image = addwsl.getAttribute("data-pajp-product-image");
      var page = addwsl.getAttribute("data-page");
      var shop_id = addwsl.getAttribute("data-pajp-shop-id");
      var token = document.getElementById("pajp-wsl-token").value;
    
      var wsl_btn = addwsl.parentNode;
    
      axios.post('https://pajphost.com/customer/public/api/checkInWishlist', {
            customer_id: customer_id,
            product_id: product_id,
            variant_id: variant_id,
            shop_id: shop_id,
          })
          .then(function(response){
        	
            if(response.data == 1){
              	//console.log("Si está");
				document.getElementsByClassName("pajp-remove-from-wsl-btn")[0].style.display = "inline-block";
                document.getElementsByClassName("pajp-add-to-wsl-btn")[0].style.display = "none";
            }else{
            	document.getElementsByClassName("pajp-remove-from-wsl-btn")[0].style.display = "none";
                document.getElementsByClassName("pajp-add-to-wsl-btn")[0].style.display = "inline-block";
            }
              
          })
          .catch(function(error){
              console.log(error);
          });
  };

window.pajpApp.remove_product_outside = function () {
    var that = this;
    var a = document.querySelectorAll('.pajp-remove-from-wsl-btn');
    a.forEach(function (item, index) {
      if (typeof item.addEventListener != "function") {
        return;
      }
      item.addEventListener('click', function (e) {
        var removewsl = this;
        clicked_remove_button = removewsl;
        var customer_id = removewsl.getAttribute("data-pajp-customer-id");
        var customer_email = removewsl.getAttribute("data-pajp-customer-email");
        var product_id = removewsl.getAttribute("data-pajp-product-id");
        var variant_id = removewsl.getAttribute("data-pajp-variant-id");
        var product_handle = removewsl.getAttribute("data-pajp-product-handle");
        var product_title = removewsl.getAttribute("data-pajp-product-title");
        var product_image = removewsl.getAttribute("data-pajp-product-image");
        var page = removewsl.getAttribute("data-page");
        var shop_id = removewsl.getAttribute("data-pajp-shop-id");

        axios.post('https://pajphost.com/customer/public/api/removeFromWishlist', {
          customer_id: customer_id,
          product_id: product_id,
          variant_id: variant_id,
          shop_id: shop_id,
        })
        .then(function(response){
          	//Remove
        	//console.log(response);
          	item.parentElement.parentElement.remove()
            
            var removewsl = document.querySelectorAll(".pajp-wsl-product-row");
            if (removewsl.length < 1) {
              document.querySelector('.pajp-wishlist-ul').classList.add("pajp-hidden");
              document.querySelector('.pajp-wsl-view-empty').classList.remove("pajp-hidden");
            }
          	//window.pajpApp.get_wishlist_products_using_ajax();
        })
        .catch(function(error){
        	console.log(error);
        });
      });
    });
  };

window.pajpApp.add_to_cart_event_outside = function () {
    var add_cart = document.querySelectorAll('.pajp-wsl-add-to-cart');
    var that = this;
    add_cart.forEach(function (item, index) {
      if (typeof item.addEventListener != "function") {
        return;
      }
      item.addEventListener('click', function (e) {
        var liParent = item.closest('li.pajp-card-box');
        //console.log(liParent);
        var id = liParent.getAttribute("data-pajp-wishlist-product-handle");
        var variant_id = liParent.getAttribute("data-pajp-wishlist-variant-handle");
        //var quantity = liParent.querySelector('input.pajp-product-quantity').value;
        
        //liParent.getAttribute("data-pajp-wishlist-product-handle")
        //liParent.querySelector('input.pajp-product-quantity')
        
        
        //var quantity = this.closest('li').querySelector('.pajp-wsl-product-variant-quantity').value;
        /*var select = this.closest('li').querySelector('.product-variant-options');
        
        var data = "id=" + id + "&quantity=1";
        that.addToCart(data, function (line_item) {
          location.href = "/cart";
        }, function () {});*/
        
        axios.post('/cart/add.js', {
          items: [
            {
              quantity: 1,
              id: variant_id
             
            }
          ]
        })
        .then(function(response){
          //console.log("Es por aqui");
          	//console.log("Good: "+response);
        	//alert("Success " + quantity);

          	pajpApp.showToast("Successfuly added", true);
          
            $('body').trigger('added.ajaxProduct');
          
           
        })
        .catch(function(error){
          	console.log("Bad: "+error);
        	pajpApp.showToast("This item is already sold out", true);
        });
        
      });
    });
  };

window.pajpApp.fillCart = function () {
  var selectors = {
      drawer: '#CartDrawer',
      cartInner: '#CartDrawer .drawer__inner',
      container: '#CartContainer',
      template: '#CartTemplate',
      fixedFooter: '.drawer__footer--fixed',
      fixedInnerContent: '.drawer__inner--has-fixed-footer',
      cartBubble: '.cart-link__bubble'
    };
  $(selectors.container).empty();
  theme.cart.getCart().then(function(cart) {
    if (cart.item_count === 0) {
          $(selectors.container).append('<p class="appear-animation appear-delay-3">' + theme.strings.cartEmpty +'</p>');
        } else {
          var items = [];
          var item = {};
          var data = {};
          var animation_row = 1;
  
          $.each(cart.items, function(index, product) {
  
            var prodImg;
            if (product.image !== null) {
              prodImg = product.image.replace(/(\.[^.]*)$/, "_180x$1");
            } else {
              prodImg = '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif';
            }
  
            if (product.properties !== null) {
              $.each(product.properties, function(key, value) {
                if (key.charAt(0) === '_' || !value) {
                   delete product.properties[key];
                 }
              });
            }
  
            // If we have line-item discount, add formattedAmount to discount object
            var amount = 0;
            if (product.line_level_discount_allocations.length !== 0) {
              for (var discount in product.line_level_discount_allocations) {
                amount = product.line_level_discount_allocations[discount].amount;
  
                product.line_level_discount_allocations[discount].formattedAmount = theme.Currency.formatMoney(amount, theme.settings.moneyFormat);
              }
            }
  
            animation_row+=2;
  
            item = {
              key: product.key,
              url: product.url,
              img: prodImg,
              animationRow: animation_row,
              name: product.product_title,
              variation: product.variant_title,
              properties: product.properties,
              itemQty: product.quantity,
              price: theme.Currency.formatMoney(product.price, theme.settings.moneyFormat),
              unitPrice: theme.Currency.formatMoney(product.unit_price, theme.settings.moneyFormat),
              unitBase: theme.Currency.getBaseUnit(product),
              discountedPrice: theme.Currency.formatMoney((product.price - (product.total_discount/product.quantity)), theme.settings.moneyFormat),
              discounts: product.line_level_discount_allocations,
              discountsApplied: product.line_level_discount_allocations.length === 0 ? false : true,
              vendor: product.vendor
            };
  
            items.push(item);
          });
  
          animation_row+=2;
  
          // If we have cart discount, add a formattedAmount to the discount object
          var cartAmount = 0;
          if (cart.cart_level_discount_applications.length !== 0) {
            for (var cartDiscount in cart.cart_level_discount_applications) {
              cartAmount = cart.cart_level_discount_applications[cartDiscount].total_allocated_amount;
  
              cart.cart_level_discount_applications[cartDiscount].formattedAmount = theme.Currency.formatMoney(cartAmount,theme.settings.moneyFormat);
            }
          }
  
          data = {
            items: items,
            note: cart.note,
            lastAnimationRow: animation_row,
            cartDiscounts: cart.cart_level_discount_applications,
            cartDiscountsApplied: cart.cart_level_discount_applications.length === 0 ? false : true,
            totalPrice: theme.Currency.formatMoney(cart.total_price, theme.settings.moneyFormat)
          };
      
          var source = $(selectors.template).html();
          var template = Handlebars.compile(source);
      
          $(selectors.container).append(template(data));
        }
  });

  setTimeout(function (){
  
    window.pajpApp.initEventListeners();
              
  }, 2500); // How long you want the delay to be, measured in milliseconds.

  
  
}

window.pajpApp.initEventListeners = function() {
  var classes = {
    input: '.js-qty__num',
    plus: '.js-qty__adjust--plus',
    minus: '.js-qty__adjust--minus'
  };
  this.$wrapper = $(".js-qty__wrapper");
  this.$wrapper.each(function(index, item){

    
    $el = $(item);
    
    $input = $el.find(classes.input);
    var input_key = $input.attr('id');
    
    $plus = $el.find(classes.plus);
    $minus = $el.find(classes.minus);

    minValue =$input.attr('min') || 1;
    
    $plus.on('click', function() {

      var input_item = $(this).prev().prev();
      var qty = validateQty(input_item.val());
      qty = qty + 1;

      input_item.val(qty);
      $('body').trigger('qty' + '.ajaxcart', [input_item.attr("id"), qty]);
      
    });
  
    $minus.on('click', function() {

      var input_item = $(this).prev();
      var qty = validateQty(input_item.val());
      subtractQty(qty, input_item, input_item.attr("id"), input_item.attr('min'));
    });
  
    $input.on('change', function() {
      var input_item = $(this);
      var qty = validateQty(input_item.val());
      changeQty(qty, input_item, input_item.attr("id"));
    });

    
  });
}

function addQty(number, $input, input_key) {
  var qty = number + 1;
  changeQty(qty, $input, input_key);
}

function subtractQty(number, $input, input_key, minValue) {
  var qty = number - 1;
  if (qty <= minValue) {
    qty = minValue;
  }
  changeQty(qty, $input, input_key);
}

function changeQty(qty, $input, input_key) {
  $input.val(qty);

  theme.cart.getCart().then(function(cart) {
    $(".drawer__footer .ajaxcart__price").text(cart.total_price);
  });
  
  $('body').trigger('qty' + '.ajaxcart', [input_key, qty]);
}

function validateQty(number) {
  if((parseFloat(number) == parseInt(number)) && !isNaN(number)) {
    // We have a valid number!
  } else {
    // Not a number. Default to 1.
    number = 1;
  }
  return parseInt(number);
}

window.pajpApp.addCLickEventSizeSwatch = function(){
    
    waitForSizeLoad = setTimeout(function(){
      var sizes_element = document.querySelector('select.sized');
      sizes_element.addEventListener('change', function(e){
        
      	waitForUrlChange = setTimeout(function(){
          	const queryString = window.location.search;
              const urlParams = new URLSearchParams(queryString);
  
              const variant = urlParams.get('variant')
              //console.log(variant);
  
              //asignar el nuevo variant a los botones de add y remove
              //var variant_id = addwsl.getAttribute("data-pajp-variant-id");
              $('.pajp-add-to-wsl-btn').attr("data-pajp-variant-id", variant);
              $('.pajp-remove-from-wsl-btn').attr("data-pajp-variant-id", variant);
          
          window.pajpApp.check_wishlist();
            
          }, 100);
      });
   }, 100);
  };

(function (funcName, baseObj) {
  funcName = funcName || "docReady";
  baseObj = baseObj || window;
  var readyList = [];
  var readyFired = false;
  var readyEventHandlersInstalled = false;
  function ready() {
    if (!readyFired) {
      readyFired = true;
      for (var i = 0; i < readyList.length; i++) {
        readyList[i].fn.call(window, readyList[i].ctx);
      }
      readyList = [];
    }
  }
  function readyStateChange() {
    if (document.readyState === "complete") {
      ready();
    }
  }
  baseObj[funcName] = function (callback, context) {
    if (typeof callback !== "function") {
      throw new TypeError("callback for docReady(fn) must be a function");
    }
    if (readyFired) {
      setTimeout(function () {
        callback(context);
      }, 1);
      return;
    } else {
      readyList.push({fn: callback, ctx: context});
    }
    if (document.readyState === "complete") {
      setTimeout(ready, 1);
    } else if (!readyEventHandlersInstalled) {
      if (document.addEventListener) {
        document.addEventListener("DOMContentLoaded", ready, false);
        window.addEventListener("load", ready, false);
      } else {
        document.attachEvent("onreadystatechange", readyStateChange);
        window.attachEvent("onload", ready);
      }
      readyEventHandlersInstalled = true;
    }
  };
  
  
})("pajp_docReady", window);

pajp_docReady(function () {
  var is_wishlist_automatic = document.getElementById('pajp-is-wishlist-automatic').value;
  var addtocart_selectors = ["button[name='add']"];
  addtocart_selectors.forEach(function (selector) {
    var els = document.querySelectorAll(selector);
    if (typeof els == "object" && els) {
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        if (typeof el.addEventListener != "function") {
          return;
        }
        if (is_wishlist_automatic == 1) {
          el.parentElement.after(document.getElementById('pajp-wishlist-automatic-code').children[0], el.parentElement.firstChild)
        }
      }
    }
  })
  
  console.log("Prueba")
  window.pajpApp.addCLickEventSizeSwatch();
});

if(location.pathname == "/account"){
  
  
  window.pajpApp.get_wishlist_products_using_ajax = function () {
    
    // this function will call ajax request and get wishlisted products
    // call this function from instead of set_wishlist_products_using_ajax
    var customer_id = $("#pajp-customerID").val();
    var shop_id = Shopify.shop;
    //var token = $("#pajp-token").val();
    
    $.ajax({
      method: "get",
      url: "https://pajphost.com/customer/public/api/wishlistByCustomer",
      data: {
        shop_id: shop_id,
        customer_id: customer_id
        
      },
      success: function (data) {
        
        var variants = data.variants;
        var count = data.count;
        //var products = data.data;
        var status = data.status;
        if (status && count > 0) {
          
          $.each(variants, function (index, product) {
            
            var li = $(".pajp-wsl-li-structure").clone();
            li.removeClass("pajp-wsl-li-structure");
            li.addClass("pajp-wsl-product-row");
            //li.find('.pajp-product-title-anchor').attr('href', '/products/' + product.product_handle);
            li.attr('data-pajp-wishlist-product-handle', product.product_id);
            li.attr('data-pajp-wishlist-variant-handle', product.variant_id);

            //Nuevos atributos añadidos
            li.find(".pajp-product-img").css({
              'background': 'url(' + product.image_src + ')',
              'background-size': 'contain',
              'background-repeat': 'no-repeat',
              'background-position': 'center center',
              'background-image': product.image_src
            });
            var display_variant_price = 0;
            
            li.find('.pajp-product-title').append(product.product_title);
            li.find('.pajp-product-variant-title').append(product.variant_title);
            li.find('.pajp-product-variant-price').append(product.price);
            li.find('.pajp-product-title-anchor').attr('href', '/products/' + product.product_handle + '?variant=' + product.variant_id);
            li.find('.pajp-wsl-product-remove').attr('data-pajp-product-id', product.product_id);
            li.find('.pajp-wsl-product-remove').attr('data-pajp-product-title', product.product_title);
            li.find('.pajp-wsl-product-remove').attr('data-pajp-variant-id', product.variant_id);
            li.find('.pajp-wsl-product-remove').attr('data-pajp-shop-id', Shopify.shop);
            li.find('.pajp-wsl-product-remove').attr('data-pajp-product-handle', product.product_handle);
            li.attr('title', product.variant_title);

            li.find('.pajp-wsl-add-to-cart').click(function(e){
              var liParent = this.closest('li.pajp-card-box');
              var id = liParent.getAttribute("data-pajp-wishlist-product-handle");
              var variant_id = liParent.getAttribute("data-pajp-wishlist-variant-handle");
              console.log(variant_id);
              axios.post('/cart/add.js', {
                items: [
                  {
                    quantity: 1,
                    id: variant_id
                   
                  }
                ]
              })
              .then(function(response){
        
                  pajpApp.showToast("Successfuly added", true);
                
                  $('body').trigger('added.ajaxProduct');
                
                 
              })
              .catch(function(error){
                  console.log("Bad: "+error);
                  pajpApp.showToast("This item is already sold out", true);
              });
            });
            
            $('.pajp-wishlist-ul').append(li);
          });

          window.pajpApp.remove_product_outside();
          //window.pajpApp.add_to_cart_event_outside();
          
          $('#pajp-wishlist-size').val(count);
          $('#pajp-wishlist-limit').val(8);
          $('#pajp-wishlist-total-page').val(Math.ceil(count / 8));
          $('.pajp-wsl-view-empty').addClass('pajp-hidden');
          $('.pajp-wishlist-ul').removeClass('pajp-hidden');
          document.getElementById("pajp-wishlist-current-page").value = 1;
          //window.pajpApp.wishlist_products_obj.reset_pagination();

          /*Esta es la llamada que se reemplazo*/
          //window.pajpApp.set_wishlist_products_using_ajax();
          
          //window.pajpApp.wishlist_products_obj.remove_product();
        } else {
          $('.pajp-wsl-view-empty').removeClass('pajp-hidden');
          $('.pajp-wishlist-ul').addClass('pajp-hidden');
        }
      },
      error: function (error) {
        console.log(error);
        $('.pajp-wsl-view-empty').removeClass('pajp-hidden');
        $('.pajp-wishlist-ul').addClass('pajp-hidden');
      }
    });
  };

  window.pajpApp.set_wishlist_products_using_ajax = function () {
    window.pajpApp.set_wishlist_add_change_event();
    window.pajpApp.set_wishlist_add_click_event();
    // for gettting and setting product
    var moneyFormat = $("#pajp-shop-money-format").val();
    var shop_id = Shopify.shop;
    $("[data-pajp-wishlist-product-handle]").each(function (index, item) {
      
      var wishlist_product_selector = $(this);
      var handle = $(this).attr('data-pajp-wishlist-product-handle');
      var variant = $(this).attr('data-pajp-wishlist-variant-handle');
      
      $.ajax({
        method: 'get',
        url: 'https://pajphost.com/customer/public/api/getVariant',
        data: {
          'product_id': handle,
          'variant_id': variant
        },
        success: function (data) {
          //console.log(data);
          /*return true;
          var product = data.product;*/
          var image = 'https://cdn.shopify.com/s/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c.gif';
          if(data.image_src != null){
            var raw_src = data.image_src;
            var resolution_pos = raw_src.indexOf("?") - 4;

            var first_part = raw_src.slice(0, resolution_pos);
            var second_part = raw_src.slice(resolution_pos);
            image = first_part+"_500x500"+second_part;
            
          }
          //var extidx = image.lastIndexOf('.');
          //var extension = image.substr(extidx);
          //image = image.replace(extension, '_200x_crop_center' + extension);
          $(wishlist_product_selector).find(".pajp-product-img").css({
            'background': 'url(' + image + ')',
            'background-size': 'contain',
            'background-repeat': 'no-repeat',
            'background-position': 'center center',
            'background-image': image
          });
          var display_variant_price = 0;
          
          $(wishlist_product_selector).find('.pajp-product-title').append(data.product_title);
          $(wishlist_product_selector).find('.pajp-product-variant-title').append(data.title);
          $(wishlist_product_selector).find('.pajp-product-variant-price').append("$"+parseFloat(data.price));
          $(wishlist_product_selector).find('.pajp-product-title-anchor').attr('href', '/products/' + data.handle + '?variant=' + data.id);
          $(wishlist_product_selector).find('.pajp-wsl-product-remove').attr('data-pajp-product-id', data.product_id);
          $(wishlist_product_selector).find('.pajp-wsl-product-remove').attr('data-pajp-product-title', data.title);
          $(wishlist_product_selector).find('.pajp-wsl-product-remove').attr('data-pajp-variant-id', data.id);
          $(wishlist_product_selector).find('.pajp-wsl-product-remove').attr('data-pajp-shop-id', Shopify.shop);
          $(wishlist_product_selector).find('.pajp-wsl-product-remove').attr('data-pajp-product-handle', data.handle);
          $(wishlist_product_selector).attr('title', data.title);
          //window.flitsApp.wishlist_products_obj.reset_pagination();
        },
        error: function () {
          $(wishlist_product_selector).remove();
          //window.flitsApp.wishlist_products_obj.reset_pagination();
        }
      });
    });
    //Call to remove function content
    window.pajpApp.remove_product_outside();
    window.pajpApp.add_to_cart_event_outside();
  };

  window.pajpApp.set_wishlist_add_change_event = function () {
    
    $(document).on('change', '.flits-wsl-product-row .flits-product-variant-options', function (ev) {
      var variant_price = this.options[this.selectedIndex].getAttribute('data-flits-variant-price');
      var flits_product_variant_price_div = this.closest(".pajp-row").parentNode.querySelector('.flits-product-variant-price');
      flits_product_variant_price_div.innerHTML = variant_price;
      var flits_add_cart_btn_text = '';
      var flits_add_cart_btn = this.closest(".pajp-row").parentNode.querySelector('.flits-add-to-cart');
      var selected_product_variant_text = this.options[this.selectedIndex].innerHTML;
      if (selected_product_variant_text.indexOf('Sold Out') != -1) {
        flits_add_cart_btn_text = flits_add_cart_btn.getAttribute('data-flits-sold-out-text');
        flits_add_cart_btn.disabled = true;
        flits_add_cart_btn.classList.add("pajp-btn-danger");
      } else {
        flits_add_cart_btn_text = flits_add_cart_btn.getAttribute('data-flits-add-to-cart-text');
        flits_add_cart_btn.disabled = false;
        flits_add_cart_btn.classList.remove("pajp-btn-danger");
      }
      flits_add_cart_btn.innerHTML = flits_add_cart_btn_text;
    });
  };

  window.pajpApp.set_wishlist_add_click_event = function () {

    pajp_validate_quantity = function (qty) {
      if ((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
        // We have a valid number!
        return qty;
      } else {
        // Not a number. Default to 1.
        return 1;
      }
    };
  };

  window.pajpApp.get_wishlist_products_using_ajax();
  //window.pajpApp.append_anchor_div(3);
}

window.addEventListener('load', function () {
  //hacer lo mismo para el size que no sabía que cambiaba la variante
  /*console.log("Prueba")
  window.pajpApp.addCLickEventSizeSwatch();*/
});